import { Component } from '@angular/core';
import build from '../../../build';
import { environment } from '../../../environments/environment';
import { DatePipe } from '@angular/common';
import { UserService } from '../../services/user/user.service';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
    selector: 'app-footer',
    imports: [DatePipe, MatTooltipModule],
    templateUrl: './footer.component.html',
    styleUrl: './footer.component.scss'
})
export class FooterComponent {
    public now: Date = new Date();
    version = build.version;
    versionReleaseDate = build.timestamp;
    environmentName = environment.name;

    public get user() {
        return this.userService.user;
    }

    checkRoles(userRoles: string[], permittedRoles: string[]) {
        return permittedRoles.some(role => userRoles.includes(role));
    }

    //
    constructor(private userService: UserService) { }
}
